import { useEffect, useState } from "react";

function diff(targetMs) {
  const now = Date.now();
  let d = Math.max(0, targetMs - now);
  const days = Math.floor(d / 86400000);
  d -= days * 86400000;
  const hours = Math.floor(d / 3600000);
  d -= hours * 3600000;
  const minutes = Math.floor(d / 60000);
  d -= minutes * 60000;
  const seconds = Math.floor(d / 1000);
  return { days, hours, minutes, seconds, done: targetMs <= now };
}

export default function Countdown({ targetIso, label = "Avant l'URBX" }) {
  const [t, setT] = useState(() => diff(new Date(targetIso).getTime()));
  useEffect(() => {
    const ms = new Date(targetIso).getTime();
    const id = setInterval(() => setT(diff(ms)), 1000);
    return () => clearInterval(id);
  }, [targetIso]);

  if (t.done) {
    return (
      <div className="font-cond uppercase tracking-[0.3em] text-[11px] text-[#FF4D00]">
        🎉 C&apos;est le jour J — Grand&apos;Place
      </div>
    );
  }

  const cells = [
    { v: t.days, k: "Jours" },
    { v: t.hours, k: "Heures" },
    { v: t.minutes, k: "Min" },
    { v: t.seconds, k: "Sec" },
  ];

  return (
    <div data-testid="countdown" className="flex flex-col gap-2">
      <div className="font-cond uppercase tracking-[0.3em] text-[10px] opacity-70">
        {label}
      </div>
      <div className="flex gap-2">
        {cells.map((c) => (
          <div
            key={c.k}
            className="flex-1 border-2 border-[#FDF0DF]/30 px-2 py-2 text-center min-w-0"
          >
            <div className="font-display text-2xl md:text-3xl leading-none tabular-nums">
              {String(c.v).padStart(2, "0")}
            </div>
            <div className="font-cond uppercase tracking-widest text-[9px] opacity-60 mt-1">
              {c.k}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
